export enum FrameUid {

    Deposit = "deposit-page-iframe",
    Kyc = "kyc-page-iframe",
    Professional = "professional-page-iframe",
    Documents = "documents-page-iframe",
    DepositLimits = "deposit-limits-iframe",
}
